import { Controller } from "@hotwired/stimulus"
import { showAlert } from "../lib/alerts"

// Handles toggling plant favorite (add/remove from favorites list)
// Values: listSlug, plantId, existing (boolean), count (number), currentUser (boolean)
// Targets: button, icon, count
export default class extends Controller {
  static values = { listSlug: String, plantId: Number, existing: Boolean, count: Number, currentUser: Boolean }
  static targets = ["button", "icon", "count"]

  toggle(event) {
    event.preventDefault()
    if (!this.currentUserValue) return

    if (this.existingValue) {
      this.remove()
    } else {
      this.add()
    }
  }

  add() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`${this.listSlugValue}/add`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ list: { plant_id: this.plantIdValue } })
    }).then(response => {
      if (response.ok) {
        this.existingValue = true
        this.countValue = this.countValue + 1
        this.render()
        showAlert("Added to favourites")
      }
    })
  }

  remove() {
    this.buttonTarget.setAttribute("disabled", "disabled")
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`${this.listSlugValue}/remove`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ list: { plant_id: this.plantIdValue } })
    }).then(response => {
      if (response.ok) {
        this.existingValue = false
        this.countValue = this.countValue - 1
        this.buttonTarget.removeAttribute("disabled")
        this.render()
        showAlert("Removed from favourites")
      }
    })
  }

  render() {
    if (!this.currentUserValue) {
      this.element.innerHTML = `<span><svg class="icon icon-gray"><use href="/icons/__remixicon.sprite.svg#heart-add-line"/></svg></span>`
      return
    }

    if (this.existingValue) {
      this.element.innerHTML = `<button class="btn-tertiary -has-icon" data-plant-favorite-target="button" data-action="click->plant-favorite#toggle"><svg class="icon icon-danger"><use href="/icons/__remixicon.sprite.svg#heart-add-fill"/></svg><span class="profile-action-count" data-plant-favorite-target="count">${this.countValue}</span></button>`
    } else {
      this.element.innerHTML = `<button class="btn-tertiary -has-icon" data-plant-favorite-target="button" data-action="click->plant-favorite#toggle"><svg class="icon icon-primary"><use href="/icons/__remixicon.sprite.svg#heart-add-line"/></svg><span class="profile-action-count" data-plant-favorite-target="count">${this.countValue}</span></button>`
    }
  }
}
